// src/components/VyjezdyPage.jsx
import React from "react";
import VyjezdyForm from "./VyjezdyForm";

export default function VyjezdyPage(props) {
  return <VyjezdyForm {...props} />;
}
